<template>
  <div :class="[popperClass, 'input-number-wrap']">
    <div :class="['minus', value <= min || disabled ? 'disabled' : '']" @click="changeVal(-1)">
      <img src="~@/assets/images/btn-count-minus.png" />
    </div>
    <input type="number" v-model.number="val" pattern="[0-9]*" :disabled="disabled ? 'disabled' : false" @input="inputValue">
    <div :class="['plus', value >= max || disabled ? 'disabled' : '']" @click="changeVal(1)">
      <img src="~@/assets/images/btn-count-plus.png" />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: [Number, String],
    disabled: Boolean,
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 99,
    },
    popperClass: {
      type: String,
      default: ''
    },
  },
  computed: {
    val: {
      get () {
        return this.value
      },
      set () {},
    },
  },
  methods: {
    inputValue (event) {
      let value = event.target.value

      if (value >= this.max) value = this.max
      if (value <= this.min) value = this.min

      this.$emit('change', parseInt(value))
    },
    changeVal (step) {
      if (this.disabled) return

      let val = this.value + step

      if (val >= this.max) val = this.max
      if (val <= this.min) val = this.min

      this.$emit('change', val)
    },
  },
}
</script>

<style lang="scss" scoped>
  .input-number-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 144px;
    height: 40px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #ececec;

    input {
      width: 48px;
      height: 40px;
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      color: #333;
      text-align: center;
      background: #fff;
      user-select: auto !important;
      -webkit-user-select: auto !important;

      &[disabled] {
        cursor: not-allowed;
      }
    }

    .minus,
    .plus {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 40px;
      font-size: 16px;
      color: #FA006E;
      background: #F6F6F6;
      font-weight: 500;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }

      &.disabled {
        color: #DDDDDD;
        cursor: not-allowed;
      }
    }
  }
  .input-number-mini {
    border: none;
    .minus,
    .plus {
      color: #666;
      width: 30px;
      height: 30px;
      border-radius: 8px;
    }
    input {
      flex-grow: 1;
      background: none;
    }
  }
</style>
